(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    function resizing(paras, tailles, max) {
        for (var i = 0; i < paras.length; i++) {
            tailles.push(jQuery(paras[i]).css('height'));
            tailles[i] = tailles[i].replace('px', '');
            if (tailles[i] > max) {
                max = tailles[i];
            }
        }

        for (var i = 0; i < paras.length; i++) {
            jQuery(paras[i]).css('height', max);
        }
    }

    jQuery( document ).ready(function() {
        var paras = jQuery('.pres-employee div.team-member-desc p:first-child');
        var tailles = [];
        var max = 0;
        resizing(paras, tailles, max);
        jQuery( window ).resize( resizing(paras, tailles, max) );
    });

})));
//# sourceMappingURL=serrain-child.min.js.map
